import React from 'react';
import {Empty, Space, EmptyProps} from "antd";
import './no-data.css'

const NoData = (props: EmptyProps) => (<Space className={'nodata_space'}><Empty {...props} image={Empty.PRESENTED_IMAGE_SIMPLE}/></Space>)

export default NoData